const getDomain = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:3000';
    }
    return 'https://engagement-newscaster-api-acc.lwdev.nl';
}

export default {
    getDomain
}